import { createUseStyles } from 'react-jss';
import colors from "../../../utils/colors";

var styles = {
  sliderWrapper: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '95%',
    '&:not(:last-child)': {
      marginBottom: '1rem'
    }
  },
  slider: {
    marginLeft: '0.8rem' // for vertical title alignment
  },
  sliderTitle: {
    fontSize: '1.6rem',
    color: colors.neutral[700],
    marginBottom: '1rem',
    marginTop: 0
  },

  rangeValues: {
    marginBottom: '1rem',
    marginTop: 0,
    textAlign: 'center',
    fontSize: '1.4rem'
  },
  range: {
    minHeight: '4rem', // with marks
    // styles of handles
    '& .rc-slider-handle': {
      opacity: 1,
      backgroundColor: colors.blue[600],
      border: "0.1rem solid ".concat(colors.blue[600])
    },
    // Active handle, important is needed to change default styles
    '& .rc-slider-handle-dragging': {
      borderColor: "".concat(colors.blue[600], " !important"),
      boxShadow: "0 0 0 0.5rem ".concat(colors.blue[200], " !important")
    }
  },
  rangeSmallViewTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '1rem',
    alignItems: 'center',
    '& p:first-child': {
      maxWidth: '12rem'
    }
  }
};

var createStyles = createUseStyles(styles);
export { createStyles };
//# sourceMappingURL=style.js.map